import {
    type RewriteRule,
    type ValidationResult,
    validateRewriteRuleConfig,
} from '@lib/string-rewriter';
import { isObject } from 'lodash';

export type DeeplinkRewriteRules = {
    ios: RewriteRule | null;
    android: RewriteRule | null;
};

export type CtaConfig = {
    deeplinkRewriteRules: DeeplinkRewriteRules | null;
};

const DEFAULT_CTA_CONFIG: CtaConfig = {
    deeplinkRewriteRules: null,
};

const sanitizeDeeplinkRewriteRules = (
    template: unknown
): DeeplinkRewriteRules | null => {
    if (isObject(template)) {
        const iosValidationResult =
            'ios' in template
                ? validateRewriteRuleConfig(template.ios)
                : ({
                      ok: false,
                      errors: ['No iOS rewrite rule config provided.'],
                  } satisfies ValidationResult);
        const androidValidationResult =
            'android' in template
                ? validateRewriteRuleConfig(template.android)
                : ({
                      ok: false,
                      errors: ['No Android rewrite rule config provided.'],
                  } satisfies ValidationResult);
        const ios = iosValidationResult.ok ? iosValidationResult.result : null;
        const android = androidValidationResult.ok
            ? androidValidationResult.result
            : null;
        if (ios || android) {
            return { ios, android };
        }
    }
    return null;
};

export const sanitizeCtaConfig = (config: unknown): CtaConfig => {
    if (!isObject(config)) return DEFAULT_CTA_CONFIG;

    const deeplinkRewriteRules =
        'deeplinkRewriteRules' in config
            ? sanitizeDeeplinkRewriteRules(config.deeplinkRewriteRules)
            : null;

    return {
        deeplinkRewriteRules,
    };
};
